import { render } from "./RadarShow.vue?vue&type=template&id=4b0df94f&scoped=true"
import script from "./RadarShow.vue?vue&type=script&lang=js"
export * from "./RadarShow.vue?vue&type=script&lang=js"

import "./RadarShow.vue?vue&type=style&index=0&id=4b0df94f&lang=scss&scoped=true"

import exportComponent from "E:\\uni-app项目\\kxsns-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b0df94f"]])

export default __exports__